import _ from "lodash";

const accessMap = {
  'None': 'no_access',
  'Submit': 'submit_access',
  'Modify': 'modify_access'
}

const getColumns = (customForms) => {
  let columns = [
    {
      data: 'user_id',
      type: 'text',
      readOnly: true
    }, {
      data: 'name',
      type: 'text',
      readOnly: true
    }
  ]

  _.forEach(customForms, customForm => {
    columns.push({
      data: customForm.id,
      editor: 'select',
      selectOptions: ['None', 'Submit', 'Modify']
    })
  })

  return columns
}

const getColHeaders = (customForms) => {
  let colHeaders = ['', 'Employee Name'];

  _.forEach(customForms, customForm => {
    colHeaders.push(customForm.title)
  })

  return colHeaders;
}

const getColumnWidth = (customForms) => {
  let colWidth = [1, 200]

  _.forEach(customForms, customForm => {
    let width = customForm.title.length * 8;
    width = Math.max(width, 125);
    colWidth.push(width);
  })

  return colWidth;
}

function generateData(customFormUsers, changesArray) {
  if (changesArray.length == 0) return [];

  const data = [];
  _.forEach(changesArray, item => {
    const [ index, customFormId, oldValue, newValue ] = item;
    if (oldValue === newValue) return;

    data.push({
      user_id: customFormUsers[index].user_id,
      custom_form_id: customFormId,
      access: accessMap[newValue]
    })
  });

  return data;
}

export {
  getColumns,
  getColHeaders,
  getColumnWidth,
  generateData
};
